import { forwardRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { IconNames } from '@shipengine/giger-theme';
import { ButtonSize, ButtonVariant } from '../../../utils/buttonStyles.js';
import { Typography } from '../../../components/Typography/Typography.js';
import { getDropzoneStyles, getTextStyles, getImageStyles } from './ImageUploaderStyles.js';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';
import { DefaultLabelValues } from './types/labels.js';
import { ImagePreview } from './components/ImagePreview/ImagePreview.js';
import { Icon } from '../../../components/Icon/Icon.js';
import { Button } from '../../../components/Button/Button.js';

const ImageUploader = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    'data-id': dataId,
    disabled = false,
    image,
    labels,
    name,
    onChange,
    ...dropzoneProps
  } = _ref;
  const {
    isDragActive,
    getRootProps,
    getInputProps
  } = useDropzone({
    maxSize: 200000,
    multiple: false,
    onDrop: onChange,
    disabled,
    ...dropzoneProps
  });
  const handleRemove = () => {
    onChange([], [], undefined);
  };
  return jsxs("div", {
    "data-id": dataId,
    css: className,
    children: [!image && jsxs("div", {
      css: getDropzoneStyles(isDragActive, disabled),
      ...getRootProps(),
      children: [jsx("input", {
        "data-id": "file-input",
        disabled: disabled,
        ref: ref,
        name: name,
        ...getInputProps()
      }), !isDragActive ? jsxs(Fragment, {
        children: [jsx(Icon, {
          name: IconNames.IMPORT,
          css: getTextStyles
        }), jsx(Button, {
          disabled: disabled,
          size: ButtonSize.SMALL,
          children: (labels === null || labels === void 0 ? void 0 : labels.toUpload) || DefaultLabelValues.UPLOAD
        }), jsx(Typography, {
          css: getTextStyles,
          variant: "small",
          children: (labels === null || labels === void 0 ? void 0 : labels.toDrag) || DefaultLabelValues.DRAG
        })]
      }) : jsxs(Fragment, {
        children: [jsx(Icon, {
          name: IconNames.DRAG_DROP
        }), jsx(Typography, {
          css: getTextStyles,
          variant: "small",
          children: (labels === null || labels === void 0 ? void 0 : labels.toDrop) || DefaultLabelValues.DROP
        })]
      })]
    }), image && jsxs(Fragment, {
      children: [jsx(ImagePreview, {
        css: getImageStyles,
        image: image
      }), jsx(Button, {
        variant: ButtonVariant.TEXT,
        onClick: handleRemove,
        disabled: disabled,
        children: (labels === null || labels === void 0 ? void 0 : labels.toRemove) || DefaultLabelValues.REMOVE
      })]
    })]
  });
});
ImageUploader.displayName = 'ImageUploader';

export { ImageUploader };
//# sourceMappingURL=ImageUploader.js.map
